module.exports = __webpack_public_path__ + "static/img/babyselected.422eb07d.svg";